import { useContext } from 'react';
import { onMouseLeaveContext } from './context';

export const useOnMouseLeave = () => {
  const onMouseLeave = useContext(onMouseLeaveContext);
  return onMouseLeave;
};
